export default "/images/16f21ce549f1d88f42ffcee8216e3615.avif";